import React from 'react';
import { Spin } from 'antd';
import "./index.css"
class CaseImage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            src: this.props.src ? this.props.src : '',
            atl: this.props.atl ? this.props.atl : '',
            isloading: true
        }
    }
    handleImageLoaded() {
        this.setState({
            isloading: false
        });
    }

    handleImageErrored() {

    }

    render() {
        let { src } = this.state;
        return (
            <div style={{ backgroundColor: "#000", marginTop: 8, textAlign: "center" }}>
                {this.isloading ? <Spin /> : ""}
                <div className="content-wrapper">
                    <img atl={this.state.atl} style={{ width: "100%" }}
                        src={src}
                        onLoad={this.handleImageLoaded.bind(this)}
                        onError={this.handleImageErrored.bind(this)}
                    />
                </div>
            </div>
        );
    }
}

export default CaseImage;